<script setup>
import DeleteButton from "@/components/common/button/deleteButton.vue";
import AddButton from "@/components/common/button/addButton.vue";
import axios from "@/axios";

import {computed, onMounted, ref, toRef, watch} from "vue";
import {useLanguageStore, useComStore} from "@/pinia";
const languageStore = useLanguageStore();
import CodeInsertModal from "@/components/modal/comCode/codeInsertModal.vue";
import {useToast} from "@/composables/useToast";

const toast = useToast();
import CodeDetailModal from "@/components/modal/comCode/codeDetailModal.vue";

const title = computed(() => languageStore.get('basicCodeManagement'))
const emits = defineEmits(['set_title'])
const comStore = useComStore();


const codes = toRef(comStore.getCodes);
const selectedGroupCode= ref(comStore.getGroupCodes.value[0]);
const selectedUpperCode = ref("");
const insertModal = ref(false);
const groupCodes = ref(comStore.getGroupCodes);
const detailModal = ref(false);


const getCode = () => {
  return codes.value.find(s => s.codeId === selectedUpperCode.value)
}

const set_detailModal = (data) =>{
  detailModal.value = data;
}
const fn_insert = (data)=>{
  axios.get("/api/code/verify/" + data.codeId, {headers: {'Content-Type': 'application/json'}})
      .then(s => {
        console.log("codeId : " + data.codeId + " data : " + s.data);
        if(s.data){
          toast.warning(languageStore.get('idInUse'));
        }else{
          comStore.insertCommonCode(data)
        }
      });
  set_insertModal(false);
}

const checkDelete = (codeId) => {
  const findCode = codes.value.find(s=>s.codeId == codeId);
  return findCode && findCode.useYn == 1;
}

const set_insertModal = (data)=>{
  insertModal.value = data
}

const fn_delete = ()=>{
  const selectCode = selectedUpperCode.value ;
  if(selectCode == "" || selectCode == null) {
    toast.warning(languageStore.get('pleaseSelectChildCode'))
    return;
  }
  if(checkDelete(selectCode)){
    comStore.deleteCommonCode(selectCode);
  }else{
    toast.warning(languageStore.get('alreadyNotUsed'))
  }
}

const selectUpperCode = (data)=>{
  selectedUpperCode.value = data
}
const selectGroupCode = (data)=>{
  selectedUpperCode.value = "";
  selectedGroupCode.value = data;
}
onMounted(()=>{
  emits('set_title', title.value)
})
watch(title, (v) => emits('set_title', v))

</script>

<template>
  <v-snackbar v-model="toast.show.value" :color="toast.color.value" :timeout="toast.timeout.value" location="top">
    {{ toast.message.value }}
    <template v-slot:actions>
      <v-btn variant="text" @click="toast.close()">{{ languageStore.get('close') }}</v-btn>
    </template>
  </v-snackbar>
  <div class="mainArea">
    <div class="topCodeArea">
      <div class="topArea">
        <div class="subTitle">{{ languageStore.get('parentCode') }}</div>
      </div>
      <div class="listArea">
        <template v-for="(gc, index) in groupCodes" :key="index" >
          <div v-if="selectedGroupCode == gc" class="selectedGroupCode">
            {{gc}}
          </div>
          <div v-else class="groupCode" @click="selectGroupCode(gc)">
            {{gc}}
          </div>
        </template>
      </div>
    </div>
    <div class="downCodeArea">
      <div class="topArea">
        <div class="subTitle">{{ languageStore.get('childCode') }}</div>
        <div class="addDeleteButtonArea">
          <add-button @modalSetter="set_insertModal(true)"></add-button>
          <delete-button @click="fn_delete"></delete-button>
        </div>
      </div>
      <div class="listArea">
        <template v-for="code in codes" :key="code.codeId">
          <template v-if="selectedGroupCode == code.grpCode">
            <div v-if="selectedUpperCode == code.codeId" class="selectUpperCode" @dblclick="set_detailModal(true)">
              <div>{{code.codeId}}</div>
              <div>{{code.codeNm}}</div>
              <div>{{code.memo}}</div>
              <div>{{code.useYn == 1  ? languageStore.get('use') : languageStore.get('notUse')}}</div>
            </div>
            <div v-else class="upperCode" @click="selectUpperCode(code.codeId)" @dblclick="set_detailModal(true)">
              <div>{{code.codeId}}</div>
              <div>{{code.codeNm}}</div>
              <div>{{code.memo}}</div>
              <div>{{code.useYn == 1  ? languageStore.get('use') : languageStore.get('notUse')}}</div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
  <code-insert-modal
      :insert-modal="insertModal"
      @set_insertModal="set_insertModal"
      @fn_insert="fn_insert"
  ></code-insert-modal>
  <code-detail-modal
      v-if="detailModal"
      :detail-modal ="detailModal"
      :code-value = getCode()
      @set_detail-modal = "set_detailModal"
  ></code-detail-modal>
</template>

<style scoped>
.mainArea{
  display: flex;
  flex-direction: row;
}
.topCodeArea{
  width: 24vw;
  background-color: white;
  height: 70vh;
  border-radius: 10px;
  margin: 20px;
}
.downCodeArea{
  width: 38vw;
  background-color: white;
  height: 70vh;
  border-radius: 10px;
  margin: 20px;
}
.addDeleteButtonArea{
  display: flex;
  position: relative;
  left: 21vh;

}
.topArea{
  display: flex;
  align-items: center;
  height: 13%;
  justify-content: center;
  border-bottom: 1px solid #AFAFAF;
  padding: 10px
}
.subTitle{
  font-size: 1.5rem;
  font-weight: bold;
}
.groupCode{
  height: 6vh;
  display: flex;
  font-size: 1.2rem;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #C7C7C7;
  cursor: pointer;
  flex-direction: column;
}
.groupCode:hover{
  background-color: #052C65;
  color: white;
}
.selectedGroupCode {
  height: 6vh;
  display: flex;
  font-size: 1.2rem;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #C7C7C7;
  background-color: #052C65;
  color: white;
  flex-direction: column;
}
.upperCode{
  height: 5vh;
  display: grid;
  grid-template-columns: 15% 50% 20% 15%;
  align-items: center;
  border-bottom: 1px solid #C7C7C7;
  padding: 0px 10px 0px 20px;
  cursor:pointer;
}
.upperCode:hover{
  background-color: #052C65;
  color: white;
}
.selectUpperCode{
  height: 5vh;
  display: grid;
  grid-template-columns: 15% 50% 20% 15%;
  align-items: center;
  border-bottom: 1px solid #C7C7C7;
  padding: 0px 10px 0px 20px;
  background-color: #052C65;
  color: white;
}
</style>